import React from "react";
import {
  XMarkIcon,
  ExclamationTriangleIcon,
} from "@heroicons/react/24/outline";

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  memberName: string;
}

export const TMConfirmRemovalModal: React.FC<ModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  memberName,
}) => {
  if (!isOpen) return null;

  const handleContentClick = (e: React.MouseEvent) => {
    e.stopPropagation();
  };

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black bg-opacity-50 transition-opacity"
      onClick={onClose}
    >
      <div
        className="bg-white rounded-lg shadow-xl w-full max-w-md transform transition-all"
        onClick={handleContentClick}
      >
        <div className="p-6">
          <div className="flex items-center justify-between mb-4">
            <div className="flex items-center space-x-2">
              <ExclamationTriangleIcon className="w-6 h-6 text-red-500" />
              <h2 className="text-xl font-bold text-gray-900">
                Confirmar eliminación
              </h2>
            </div>
            <button
              onClick={onClose}
              className="text-gray-400 hover:text-gray-500 transition"
            >
              <XMarkIcon className="w-5 h-5" />
            </button>
          </div>

          <div className="mb-6">
            <p className="text-gray-600">
              ¿Estás seguro de que deseas eliminar a{" "}
              <span className="font-semibold">{memberName.toUpperCase()}</span> del equipo?
            </p>
          </div>

          <div className="flex justify-end space-x-3">
            <button
              onClick={onClose}
              className="flex items-center px-3 py-2 bg-gray-100 text-gray-700 font-semibold rounded hover:bg-gray-200 transition"
            >
              <XMarkIcon className="w-4 h-4 mr-1" />
              Cancelar
            </button>
            <button
              onClick={onConfirm}
              className="flex items-center px-3 py-2 bg-red-500 text-white font-semibold rounded hover:bg-red-600 transition"
            >
              <ExclamationTriangleIcon className="w-4 h-4 mr-1" />
              Eliminar
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
